<button type="button" class="close close_modal" style="outline: none;" (click)="dismissAll()" data-dismiss="modal"><span aria-hidden="true">×</span></button>

<div class="modal-header">
    <h5 class="modal_title">VIP Tokens Report</h5>
</div>
<div class="modal-body p-4">
    <div class="row">
        <div class="col-md-12 add_ded_tbl">
            <table class="table">
                <thead class="thead-light">
                    <tr>
                        <th scope="col">Sr.No.</th>
                        <th scope="col">Detail</th>
                        <th scope="col">VIP Tokens</th>
                        <th scope="col">Txn. Status</th>
                        <th scope="col">Ded. From</th>
                        <th scope="col">Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i of transactions; let a = index">
                        <th scope="row">{{ a + 1 }}</th>
                        <td>
                            <span *ngIf="i.add_deduct == 'add'">Add VIP Token</span>
                            <span *ngIf="i.add_deduct == 'deduct'">Deduct VIP Token</span>
                        </td>
                        <td>{{ i.tokens }}</td>
                        <td>
                            <span *ngIf="i.add_deduct == 'add'">{{ i.status }}</span>
                            <span *ngIf="i.add_deduct == 'deduct'">complete</span>
                        </td>
                        <td>
                          <span *ngIf="i.type == 0"><i class="fas fa-coins"></i></span>
                          <span *ngIf="i.type == 1"><i class="fab fa-google"></i></span>
                          <span *ngIf="i.type == 2"><i class="fab fa-instagram"></i></span>
                          <span *ngIf="i.type == 3"><i class="fab fa-twitter"></i></span>
                          <span *ngIf="i.type == 4"> GM {{i.show}} </span>
                          <span *ngIf="i.type == 5"> ST {{i.show}} </span>
                          <span *ngIf="i.type == 6 || i.type == 7"> {{i.show}} </span>
                        </td>
                        <td>{{ i.created * 1000 | date:'mediumDate' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
